import React from 'react';
import { Box, HStack, Spacer, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
interface props {
  selectTab: number;
}

export const selectTabEnum = {
  None: 0,
  AdminUsers: 1,
  Trains: 2,
  TrainGroups: 3,
  Category: 4,
  Phrases: 5,
  TransitLogs: 6,
  MailingList: 7,
  Signages: 8,
  Settings: 9
};

export const MaintenanceHeader: React.FC<props> = (props) => {
  const { selectTab } = props;

  const GetBgColor = (num: number) => {
    if (selectTab === num) {
      return 'gray';
    }
    return 'transparent';
  };

  const GetForeColor = (num: number) => {
    if (selectTab === num) {
      return 'white';
    }
    return 'silver';
  };

  return (
    <HStack h={12} bgColor='gray.800' color='white'>
      <Text mr={10} color='silver' ml='10' fontSize='16'>
        メンテナンス
      </Text>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.AdminUsers)}
        color={GetForeColor(selectTabEnum.AdminUsers)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/admin_users'>乗務員</Link>
      </Box>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.Trains)}
        color={GetForeColor(selectTabEnum.Trains)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/trains'>車両</Link>
      </Box>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.TrainGroups)}
        color={GetForeColor(selectTabEnum.TrainGroups)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/train_groups'>車両形式</Link>
      </Box>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.Category)}
        color={GetForeColor(selectTabEnum.Category)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/categories'>カテゴリ</Link>
      </Box>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.Phrases)}
        color={GetForeColor(selectTabEnum.Phrases)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/phrases'>定型文</Link>
      </Box>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.MailingList)}
        color={GetForeColor(selectTabEnum.MailingList)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/mailinglists'>メーリングリスト</Link>
      </Box>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.Signages)}
        color={GetForeColor(selectTabEnum.Signages)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/signages'>サイネージ</Link>
      </Box>
      <Box
        pl={2}
        pr={2}
        bgColor={GetBgColor(selectTabEnum.Settings)}
        color={GetForeColor(selectTabEnum.Settings)}
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/admin/settings'>初期設定</Link>
      </Box>

      <Spacer />
      <Box
        bgColor='transparent'
        color='silver'
        fontSize='14'
        _hover={{ bg: 'gray', color: 'white' }}
      >
        <Link to='/location'>閉じる</Link>
      </Box>
    </HStack>
  );
};
